// eslint-disable-next-line
/* eslint-disable */
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { i18n } from '@/main'
import { generateKey, sha256Encrypt, encryptData, decryptData } from "@/utils/crypto";
import { getToken } from '@/utils/auth'

// Encrypt Swither
const encryptQuery = true

// create an axios instance
const protocol = window.location.protocol // 协议
const host = window.location.host // server
let baseURL = protocol + '//' + host + '/'

const service = axios.create({
  baseURL: process.env.BASE_API,

  // baseURL: baseURL,
  timeout: 900000 // request timeout
})

const cancelTokenSources = new Map() // 定义cancel队列

// request interceptor
service.interceptors.request.use(
  config => {
    if (!config.hasOwnProperty('cancelToken')) {
      // 排除不需要cancel的请求
      const source = axios.CancelToken.source()

      cancelTokenSources.set(source.token, source.cancel) // 加入cancel队列
      config.cancelToken = source.token
    }

    // let url = config.url

    // if(config.method === 'get' || config.method === 'GET'){
    //   for(let key in config.params){
    //    if(config.params[key]) config.params[key] = config.params[key].toString().indexOf(' ') ? encodeURI(config.params[key]) : config.params[key]
    //   }
    // }
    // Do something before request is sent
    // console.log( getToken());
    config.headers['PageName'] = store.state.app.pageName
    //config.headers['x-source'] = window.__POWERED_BY_QIANKUN__ ? 'AICC' : ''
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = 'Token ' + store.getters.token
    }
    if (config.isNeedRequestId) {
      config.headers['Request-Id'] = new Date().getTime()
    }
    // if (config.isNeedEncode) {
    //   url += '?'
    //   let keys = Object.keys(config.params)
    //   for (let key of keys) {
    //     url += `${key}=${encodeURIComponent(config.params[key])}&`
    //   }
    //   url = url.substring(0, url.length - 1)
    //   config.params = {}
    // }
    // config.url = url

    if (encryptQuery) {
      let encryptStr = null;
      const AesKey = generateKey();

      if (config.method == 'get' || config.params) {
        let uri = config.params;
        if (typeof config.params === 'object') {
          let urls = []
          let keys = Object.keys(config.params)
          for (let key of keys) {
            if (typeof config.params[key] !== 'undefined' && config.params[key] !== null)
              urls.push(`${key}=${config.params[key]}`)
          }
          uri = urls.join('&')
        }
        // config.headers["X-Uncrypted-Query"] = JON.stringify(config.params) // 这是调试模式用的，在headers里加入没有加密的字符串
        config.headers["X-Forward-For"] = sha256Encrypt(uri)
        encryptStr = encryptData(AesKey, uri, 'GET')
        // config.params = encryptStr // 将加密后的数据作为新参数传递
        config.url = config.url + '?' + encodeURIComponent(encryptStr)
        config.params = {}
      } else if (config.method == 'post' || config.method == 'POST') {
        if (config.data === undefined) config.data = {}
        config.headers["X-Forward-For"] = sha256Encrypt(typeof config.data === 'string' ? config.data : JSON.stringify(config.data))
        encryptStr = encryptData(AesKey, config.data, typeof config.data === 'string' ? 'GET' : 'POST')
        config.data = encryptStr
      }
      config.headers["X-Forward-To"] = '1'
    }



    return config
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    if (response.config.cancelToken) {
      cancelTokenSources.delete(response.config.cancelToken)
    }
    if (encryptQuery && response.data && !response.data.code) {
      const AesKey = generateKey();
      response.data = decryptData(AesKey, response.data);
    }
    const code = response.data.code
    // 禁止加额外code
    if (code === -1 || code === 1 || code === 403 || code === 2 || code === 10902 || code === 10903) {
      // Message({
      //   message: response.data.status !== undefined ? response.data.status : response.data.message,
      //   type: 'error',
      //   duration: 2 * 1000
      // })

      // lxl-改成弹窗提示
      MessageBox.alert(response.data.status !== undefined ? response.data.status : response.data.message, 'Error', {
        confirmButtonText: 'OK',
        type: 'error'
      })
      return Promise.reject(response)
    }

    if (code === 10302) return Promise.reject(response)
    return response
  },
  error => {
    if (axios.isCancel(error)) {
      cancelTokenSources.delete(error.message)
    } else {
      if (!window.__POWERED_BY_QIANKUN__) {
        if (error.response.status === 401) {
          const url = error.response.config.url
          // 埋点接口忽略，userinfo401直接跳转至login
          // if (url.includes('api/bury_point')) {
          // if (url.includes('api/v2/click')) {
          if (url.includes('api/v2/account_info')) {
            store.dispatch('FedLogOut').then(() => {
              window.location.href = window.location.origin + '/login'
            })
          } else {
            // 请自行在引入 MessageBox
            MessageBox.confirm(i18n.t('login.errorMessage'), 'Confirm Logout', {
              confirmButtonText: 'Re-Login',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              store.dispatch('FedLogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            })
          }
        }
      } else {
        // console.info(error, 'err', error.response, JSON.stringify(error))
        if (error.response) {
          if (error.response.status == 401) {
            window.$globalState.runCommands(401)
          }
        }
      }
      if (error.response.status === 401) {
      } else {
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }

    Promise.reject(error)
  }
)

export default service
export const cancelTokenSource = cancelTokenSources



// WEBPACK FOOTER //
// ./src/utils/request.js